var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C14.25 5.625 8 1.25 8 1.25C8 1.25 1.75 5.625 1.75 11.25C1.75 12.9076 2.40848 14.4973 3.58058 15.6694C4.75269 16.8415 6.3424 17.5 8 17.5C9.6576 17.5 11.2473 16.8415 12.4194 15.6694C13.5915 14.4973 14.25 12.9076 14.25 11.25Z",
    fill: "#525E9D",
    stroke: "#525E9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/Sample.136815331f9abf6b5e4d4b9c1ffc2391.svg";
export { ForwardRef as ReactComponent };